import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import { confirmDialog } from "primereact/confirmdialog";

import SelectStateNew from "./components/selectStateNew"; 
import Commission from "./components/Commission";
import LogisticCharge from "./components/LogisticCharge";
import QuotationDetails from "./components/QuotationDetails";
import ListItem from "./components/listItem";
import BuyerQuoteMarginSuggetions from "./components/BuyerQuoteMarginSuggetions";
import ApprovalDisplay from "./components/ApprovalsDisplay";

import { Dialog } from "primereact/dialog";
import { Button } from "../../helpers";

import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";

import { addDaysToDate, calculateBuyerQuotation, calculateQuoteApprovals, getApprovalRequestStatusDetails, getBranchComparision, getManagerIds, getUserBranch, isMobile, round } from "../../utils";

import { getBuyerRequirementsById } from "../../services/api/buyerReq";
import { getSellerDetailsBybuyerReqIdForBuyerQuote } from "../../services/api/sellerReq";
import { getBuyerQuoteByBuyerQuoteId } from "../../services/api/buyerQuote";
import { addBuyerQuote } from "../../services/api/buyerQuote";
import { fetchApprovalSecondary, fetchApprovalTypes, fetchApprovals, fetchCompanyBusinessTypes, fetchCompanyCreditPeriods, fetchCompanyWarehouses, fetchHSNMasterData, fetchMaterialBrands, fetchMaterialCategories, fetchQuoteClasses, fetchSkipSuggMarginReasons, fetchStates, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getBuyerRateContracts } from "../../services/api/buyerRateContracts";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getCompanyBillAddrs } from "../../services/api/companyBillAddr";
import { getCompanyById } from "../../services/api/company";
import { getApprovalInstancesByDocNo, insertApprovalInstances } from "../../services/api/approvalInstances";

import './index.css'
import { getActiveBuyerPOByBuyerQuoteId } from "../../services/api/buyerPO";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import NewApprovalsDisplay from "./components/NewApprovalsDisplay";

import AuditProductMobileSkeleton from "../../skeletons/AuditProductMobile";
import AuditProductSkeleton from "../../skeletons/AuditProduct";
import { getQuoteMargins } from "../../services/api/getQuoteMargins";
import { SELLER_WEIGHTAGE_APPLICABLE_AMOUNT } from "../../constants";
import { searchUsers } from "../../services/api/user";


const AuditProduct = () => {
    const { buyerQuoteId, buyerReqId } = useParams()

    const [buyerReq, setbuyerReq] = useState({})
    const [sellerReqs, setsellerReqs] = useState([])
    const [buyerReqItems, setBuyerReqItems] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [sellers, setSellers] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [initialMaterialDetails, setInitialMaterialDetails] = useState([])
    const [buyerQuote, setBuyerQuote] = useState({})
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [initialBuyerQuoteItems, setInitialBuyerQuoteItems] = useState([])
    const [visibleApprovals, setVisibleApprovals] = useState(false)
    const [quoteMargins, setQuoteMargins] = useState([])

    const [buyerCompanyDetails, setBuyerCompanyDetails] = useState('')
    const [allCompanyBillAddresses, setAllCompanyBillAddresses]  = useState([])
    const [pmBillAddresses, setPMBillAddresses]  = useState([])
    const [procmartStates, setProcmartStates] = useState([])
    const [selectedProcState, setSelectedProcmartState] = useState(null)

    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])
    const [approvalRequestStatusDetails, setApprovalRequestStatusDetails] = useState([])
    const [suggMarginBuyerQuote, setsuggMarginBuyerQuote] = useState(null)
    const [suggMarginBuyerQuoteItems, setSuggMarginBuyerQuoteItems] = useState([])

    const [selectedBuyerReqItemIds, setSelectedBuyerReqItemIds] = useState([])
    const [isActiveBuyerPOExist, setIsActiveBuyerPOExist] = useState(false)
    const [isInitialLoading, setInitialLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isStarRFQ, setIsStartRFQ] = useState(false)
    const [hasNullDocProof, setHasNullDocProof] = useState(false)
    const [visibleMarginSuggestion, setVisibleMarginSuggestion] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const companyBusinessTypes = useSelector(state => state.common.companyBusinessTypes)
    const statesDetails = useSelector((state) => state.common.states)
    const statusData = useSelector((state) => state.common.status)
    const brandData = useSelector((state) => state.common.materialBrands)
    const approvals = useSelector((state) => state.common.approvals)
    const companyWarehouses = useSelector((state) => state.common.companyWarehouses)
    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const userDetails = useSelector((state) => state.userDetails)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)
    const approvalTypes = useSelector((state) => state.common.approvalTypes)
    const quoteClasses = useSelector((state) => state.common.quoteClasses)
    const skipSuggMarginReasons = useSelector((state) => state.common.skipSuggMarginReasons)

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)

    let quotationApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.quotationApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    useEffect(() => {
        setInitialLoading(true)
        dispatch(fetchMaterialCategories())
        dispatch(fetchApprovals())
        dispatch(fetchApprovalTypes())
        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchHSNMasterData())
        dispatch(fetchStatus())
        dispatch(fetchApprovalSecondary())
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchCompanyBusinessTypes())
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchQuoteClasses())
        dispatch(fetchSkipSuggMarginReasons())
    }, [])

    useEffect(() => {
        // quotationApprovals?.length > 0
        if (quotationApprovals?.length > 0 && HSNMasterData?.length > 0 && materialCategories?.length > 0 && statusData?.length > 0 && brandData?.length > 0 && companyWarehouses?.length > 0 && statesDetails?.length > 0) {
            if (buyerReqId) {
                getBuyerReqData(buyerReqId)
            }
            if (buyerQuoteId) {
                constructBuyerQuoteData(buyerQuoteId)
            }
        }
    }, [HSNMasterData, quotationApprovals, materialCategories, statusData, brandData, companyWarehouses, statesDetails, pmCompanyConfig])

    useEffect(() => {
        calculateApprovalsNew()
    }, [buyerQuote, buyerQuoteItems, approvalInstances])

    useEffect(() => {
        const activeSellerReqItems = sellerReqItems.filter(item => item.statusId === 1);
        const sellerReqTotalAmountBeforeTax = activeSellerReqItems.reduce((sum, item) => {
            return sum + (item.quotTotalAmountBeforeTax || 0)
        }, 0)
        
        if (sellerReqTotalAmountBeforeTax >= 500000) {
            setIsStartRFQ(true)
        } else {
            setIsStartRFQ(false)
        }
        
        const sellerReqsWithQuotedItems = sellerReqs.filter(sellerReq => 
            sellerReqItems.some(item => item.sellerReqId === sellerReq.sellerReqId && item.quotTotalAmountWithTax > 0 && sellerReq.companyId !== sellerReq.pmCompanyId && item.statusId === 1)
        )
    
        const hasNullDocProof = sellerReqsWithQuotedItems.some(sellerReq => 
            sellerReq.docProof === null || 
            (Array.isArray(sellerReq.docProof) && sellerReq.docProof.length === 0)
        )
        setHasNullDocProof(hasNullDocProof)

    }, [sellerReqItems])

    const calculateApprovalsNew = () => {
        const updatedByUserDetails = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === buyerQuote.updatedBy)
        const updatedRequiredApprovals = calculateQuoteApprovals({buyerReq, buyerReqItems, quotationApprovals, buyerQuote, buyerQuoteItems, updatedByUserDetails})
        setRequiredApprovals(updatedRequiredApprovals)
        
        const pmBranchId = buyerQuote.pmBranchId
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({updatedRequiredApprovals, approvalInstances, approvals, pmBranchId})
        setApprovalRequestStatusDetails(approvalRequestStatusDetails)
    }

    const getBuyerReqData = async (buyerReqId) => {
        setInitialLoading(true)

        const response = await getBuyerRequirementsById(buyerReqId)
        if (response.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer requirement', detail: response.data.error, life: 3000 }))
        }

        const procmartBillAddrIds =  _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const allPrimaryBillAddrIds = _.uniq([...procmartBillAddrIds, response.data.buyerRequirement.billAddrId, response.data.buyerRequirement.pmBillAddrId])
        const billAddrRes = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrIds, paginator: false })
        if (billAddrRes.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'billAddrRes', detail: billAddrRes.data.error, life: 3000 }))
        }
        setAllCompanyBillAddresses(billAddrRes?.data?.data)

        const procmartBillAddrs = billAddrRes?.data?.data?.filter(eachBillAddr => procmartBillAddrIds.includes(eachBillAddr.billAddrId))

        setPMBillAddresses(procmartBillAddrs)

        const allStateIds = procmartBillAddrs.map(eachBillAddr => eachBillAddr.stateId)
        const filteredStates = statesDetails?.filter(eachState => allStateIds.includes(eachState.stateId))
        setProcmartStates(filteredStates)

        let primaryPMBillAddrState = null
        if(response.data.buyerRequirement.pmBillAddrId){
            
        }
        setSelectedProcmartState(27) 
        const buyerComapnyDetails = await getCompanyById(response.data.buyerRequirement.companyId)
        if (buyerComapnyDetails.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Company Details', detail: buyerComapnyDetails.data.error, life: 3000 }))
        }
        setBuyerCompanyDetails(buyerComapnyDetails?.data)

        const relatedBuyerBranch = buyerComapnyDetails?.data?.companyBranches?.find(eachBranch => eachBranch.branchId === response.data.buyerRequirement.branchId)
        let buyerPaymentTerms = relatedBuyerBranch?.paymentTerms
        if (!relatedBuyerBranch?.paymentTerms) {
            buyerPaymentTerms = buyerComapnyDetails?.data?.paymentTerms
        }

        const buyerReqItemsIds = response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId)
        const materialRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: buyerReqItemsIds })
        if (materialRes.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Material Code', detail: materialRes.data.error, life: 3000 }))
        }
    
        const updatedMaterialDetails = materialRes.data.map(eachMaterial => {
            return {
                ...eachMaterial, 
                isMaterialIdEditable: false, 
                newMaterialId: '', 
                isProductNameEditable: false, 
                isSpecificationEditable: false, 
                isBrandEditable: false,
                brand: eachMaterial.brandId,
                buyerReqId: response.data.buyerRequirement.buyerReqId
            }
        })

        let materialRateContractRes = []
        if (response.data.buyerRequirement.buyerReqItems?.[0]?.buyerRateContractId) {
            const buyerRateContractIds = response.data.buyerRequirement.buyerReqItems.map(eachReqItem => eachReqItem.buyerRateContractId)
            materialRateContractRes = await getBuyerRateContracts({ buyerRateContractIds: buyerRateContractIds, paginator: false, statusIds: [1, 2] })
            if (materialRateContractRes.failure) {
                setInitialLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Rate Contract Details', detail: materialRateContractRes.data.error, life: 3000 }))
            }
        }

        const quoteMarginRes = await getQuoteMargins({paginator: false, companyGroupIds: [buyerComapnyDetails.data.groupId, 0], pmBranchIds: [response.data.buyerRequirement.pmBranchId, 0]})
        if(quoteMarginRes.failure){
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Quote Margins', detail: quoteMarginRes.data.error, life: 3000 }))
        }
        setQuoteMargins(quoteMarginRes.data)

        const todayDate = new Date()
        const validityDate = addDaysToDate(todayDate, 15)

        let vendorCode = ""

        let newBuyerQuote = {}
        if (Object.keys(response.data.buyerRequirement).length > 0) {
            const pmCompanyConfig = getPMCompanyConfig(response.data.buyerRequirement.pmCompanyId)
            const relatedHSNCodes = HSNMasterData.filter(eachHSN => eachHSN.HSNCode === pmCompanyConfig.defaultHSNCode)
            const hsnGSTOptions = relatedHSNCodes.map(eachHSN => eachHSN.GSTRate)
            newBuyerQuote = {
                isNew: true,
                buyerQuoteId: uuidv4(),
                buyerReqId: response.data.buyerRequirement.buyerReqId,
                companyId: response.data.buyerRequirement.companyId,
                branchId: response.data.buyerRequirement.branchId,
                userId: response.data.buyerRequirement.userId,
                bQuoteLogisticsOption: "Free Delivery",
                bQuotLogisticsGSTRate: 0,
                bQuotLogisticsWithTax: 0,
                bQuotTotalItemAmountBeforeTax: 0,
                bQuotTotalPOTax: 0,
                bQuotTotalItemAmountWithTax: 0,
                bQuotLogisticsHSN: pmCompanyConfig.defaultHSNCode ? pmCompanyConfig.defaultHSNCode : null,
                logisticsGSTRateOptions : [0, ...hsnGSTOptions],
                billAddrId: response.data.buyerRequirement.billAddrId,
                shipAddrId: response.data.buyerRequirement.shipAddrId,
                pmBillAddrId: pmCompanyConfig.isInternational ? null : 76,  //response.data.buyerRequirement.pmBillAddrId
                pmCompanyId: response.data.buyerRequirement.pmCompanyId,
                pmBranchId: response.data.buyerRequirement.pmBranchId,
                paymentTerms: buyerPaymentTerms,
                validUpto: validityDate,
                remarks: '',
                parentDocNo: response.data.buyerRequirement.docNo,
                vendorCode: vendorCode,
                isURP: response.data.buyerRequirement.isURP,
                skipSuggMarginReasonId: null,

                logisticsGSTRateOptions: [],
                budgetaryFlag : false
            }

        }

        let updatedBuyerReqItems = response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => {
            const materialDetails = updatedMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachBuyerReqItem.materialId)
            const categoryName = materialCategories.find(eachIndustry => eachIndustry.categoryId === materialDetails.categoryId)?.categoryName
            const brandName = brandData.find(eachBrand => eachBrand.brandId === materialDetails.brandId)?.brandName
            return { 
                ...eachBuyerReqItem, 
                categoryName: categoryName, 
                categoryId: materialDetails.categoryId, 
                brandId: materialDetails.brandId, 
                brandName: brandName, 
                UOMValue: materialDetails.UOMValue
            }
        })

        updatedBuyerReqItems = updatedBuyerReqItems.sort((a, b) => a.buyerReqItemId - b.buyerReqItemId)

        setbuyerReq(response.data.buyerRequirement)
        setBuyerReqItems(updatedBuyerReqItems)
        setMaterialDetails(updatedMaterialDetails)
        setInitialMaterialDetails(JSON.parse(JSON.stringify(updatedMaterialDetails)))

        let sellerReqItemsResponse = await getSellerDetailsBybuyerReqIdForBuyerQuote(buyerReqId)
        let sellerDetails = sellerReqItemsResponse.sellers
        sellerReqItemsResponse = sellerReqItemsResponse ? sellerReqItemsResponse : {} 

        let bQuotLogisticsGSTRateOptions = []
        let buyerQuoteItemsList = []

        response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => {
            let relatedSellerReqItems = sellerReqItemsResponse?.sellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerReqItem.quotTotalAmountWithTax && eachSellerReqItem.statusId === 1) // && eachSellerReqItem.statusId === 1
            relatedSellerReqItems = relatedSellerReqItems?.length ? relatedSellerReqItems : []
            relatedSellerReqItems = _.orderBy(relatedSellerReqItems, ['unitPrice'], ['asc'])

            const relatedSellerReqIds = relatedSellerReqItems.map(eachSellerReqItem => eachSellerReqItem.sellerReqId)
            const relatedSellerReqs = sellerReqItemsResponse?.sellerReqs?.filter(eachSellerReq => relatedSellerReqIds.includes(eachSellerReq.sellerReqId))

            const allSellerlistPrice = []
            const allSellerHSNCodes = []
            const allGSTRates = []

            relatedSellerReqItems?.map(eachSellerReqItem => {
                if (eachSellerReqItem && !allSellerlistPrice.includes(eachSellerReqItem.quotListPrice)) {
                    allSellerlistPrice.push(eachSellerReqItem.quotListPrice)
                }
                if (eachSellerReqItem && !allSellerHSNCodes.includes(eachSellerReqItem.quotHSNCode)) {
                    allSellerHSNCodes.push(eachSellerReqItem.quotHSNCode)
                }
                if (eachSellerReqItem && !allGSTRates.includes(eachSellerReqItem.quotGSTRate)) {
                    allGSTRates.push(eachSellerReqItem.quotGSTRate)
                }
            })

            let gstOptions = []
            if ((allSellerHSNCodes.length === 1)) {
                const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === allSellerHSNCodes[0])
                const relatedGSTOptions = HSNCodeDetails?.map(eachHSNCode => eachHSNCode.GSTRate)
                gstOptions = relatedGSTOptions
                if (pmCompanyConfig.GSTRates){
                    gstOptions = pmCompanyConfig.GSTRates
                    let isZeroGstRateExists = relatedSellerReqItems.some(eachSelReqItem => eachSelReqItem.quotGSTRate === 0)
                    if (isZeroGstRateExists && !gstOptions.includes(0)){
                        gstOptions = [0, ...gstOptions]
                    }
                }
                if (relatedGSTOptions.length === 1) {
                    bQuotLogisticsGSTRateOptions.push(relatedGSTOptions[0])
                } else {
                    bQuotLogisticsGSTRateOptions.push(0)
                }
            }

            const relatedMaterialItem = materialRes.data.find(eachMaterialItem => eachMaterialItem.materialId === eachBuyerReqItem.materialId)
            const relateBuyerRateContract = materialRateContractRes?.data?.data?.find?.(eachRCItem => eachRCItem.buyerRateContractId === eachBuyerReqItem.buyerRateContractId)

            let unitPrice = null
            if (relateBuyerRateContract) {
                unitPrice = relateBuyerRateContract.unitPrice
            }

            let relatedBuyerQuoteItems = []
            relatedSellerReqItems.map(eachSellerReqItem => {
                const relatedCompanyWarehouse = companyWarehouses.find(eachWarehouse => eachWarehouse.shipAddrId === eachSellerReqItem?.shipAddrId)

                const newBuyerQuoteItem = {
                    buyerQuoteItemId: uuidv4(),
                    buyerQuoteId: newBuyerQuote.buyerQuoteId,
                    buyerReqId: eachSellerReqItem.buyerReqId,
                    buyerReqItemId: eachSellerReqItem.buyerReqItemId,
                    sellerReqItemId: eachSellerReqItem.sellerReqItemId,
                    materialId: relatedMaterialItem.materialId,
                    printedDesc: relatedMaterialItem.companyProdSpec,
                    // companyERPCode: null,
                    totReqQty: eachBuyerReqItem.qty,
                    bQuotSellerQty: null,
                    bQuotSellerPrice: eachSellerReqItem.quotUnitPrice,
                    bQuotListPrice: allSellerlistPrice.length === 1 ? allSellerlistPrice[0] : null,
                    bQuotUnitPrice: unitPrice,
                    bQuotSellerDiscountRate: eachSellerReqItem.quotDiscountRate ? eachSellerReqItem.quotDiscountRate : 0,
                    bQuotDiscountRate: 0,
                    bQuotMarginRate: 0,
                    bQuoteGSTRate: allGSTRates.length === 1 ? allGSTRates[0] : null, 
                    bQuoteItemAmountBeforeTax: 0,
                    bQuoteItemAmountWithTax: 0,
                    bQuotHSNCode: allSellerHSNCodes.length === 1 ? allSellerHSNCodes[0] : null,
                    leadTime: relateBuyerRateContract ? relateBuyerRateContract.leadTime : null,
                    statusId: 1,
                    buyerRateContractId: eachBuyerReqItem.buyerRateContractId,
                    companyERPCode: eachBuyerReqItem.companyERPCode,
                    brandId: relatedMaterialItem.brandId,
                    categoryId: relatedMaterialItem.categoryId,
                    warehouseName: relatedCompanyWarehouse?.warehouseName ? relatedCompanyWarehouse?.warehouseName : 'Client',
                    warehouseId: relatedCompanyWarehouse?.warehouseId ? relatedCompanyWarehouse?.warehouseId : null,
                    quotHSNCode: eachSellerReqItem.quotHSNCode,

                    isNew: true,
                    isLeadTimeEditable: response.data.buyerRequirement.orderTypeId === 2 && relateBuyerRateContract.leadTime ? false : true,
                    bQuotSellerListPrice: eachSellerReqItem.quotListPrice,
                    bQuotSellerGSTRate: eachSellerReqItem.quotGSTRate,
                    sellerLeadTime: eachSellerReqItem.quotLeadTime,
                    sellerQuoteQty: eachSellerReqItem.quotQty,
                    measure: "Discount %",
                    gstOptions: gstOptions,
                    allHSNGSTRates: gstOptions,
                    sellerUnitLogistics: eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0,
                    isSellerReqExpired: eachSellerReqItem.statusId === 2 ? true : false,
                    maxLogisticGSTRate: null,
                    isUnitPriceEditable: eachBuyerReqItem.buyerRateContractId ? false : true
                }
                newBuyerQuoteItem.sellerUnitPriceWithLogistics = newBuyerQuoteItem.bQuotSellerPrice + newBuyerQuoteItem.sellerUnitLogistics
                relatedBuyerQuoteItems.push(newBuyerQuoteItem)
            })


            let totalSellerTotalQty = 0
            relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                totalSellerTotalQty += eachBuyerQuoteItem.sellerQuoteQty
            })
            const maxBestSellerTotalQty = totalSellerTotalQty > eachBuyerReqItem.qty ? eachBuyerReqItem.qty : totalSellerTotalQty

            const bestSellerCombination = getBestSellerCombination(relatedBuyerQuoteItems, maxBestSellerTotalQty)

            const bestSellerTotalQty = _.sumBy(bestSellerCombination, 'sellerQuoteQty')

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                const relatedBestSellerQuote = bestSellerCombination.find(eachBestSellerQuote => eachBestSellerQuote.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
                if (relatedBestSellerQuote) {
                    eachBuyerQuoteItem.bQuotSellerQty = relatedBestSellerQuote.sellerQuoteQty
                }
                eachBuyerQuoteItem.totReqQty = bestSellerTotalQty //??
                return eachBuyerQuoteItem
            })

            //GST RATE LOGIC
            const maxSellerGST = _.max(relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerQty).map(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerGSTRate))
            const updatedGSTOptions = relatedBuyerQuoteItems?.[0]?.gstOptions.filter(eachGST => eachGST >= maxSellerGST)

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachQuoteItem => {
                return {...eachQuoteItem, gstOptions: updatedGSTOptions}
            })

            let vendorScore = calculateTotalVendorScore(sellerDetails, eachBuyerReqItem, relatedSellerReqs, relatedSellerReqItems)

            const isVendorRateContractExists = relatedSellerReqItems.find(eachSellerReq => eachSellerReq.vendorRateContractItemId)

            let totalSellerAmount = 0
            relatedSellerReqItems.map(eachSellerReqItem => {
                if (eachSellerReqItem.statusId === 1){
                    totalSellerAmount += eachSellerReqItem.quotTotalAmountWithTax
                }
            })

            if (isVendorRateContractExists || totalSellerAmount < SELLER_WEIGHTAGE_APPLICABLE_AMOUNT){
                vendorScore = {...vendorScore, totalProductQuotationScore: 100}
            }

            if (vendorScore.totalProductQuotationScore >= 100) {
                buyerQuoteItemsList = [...buyerQuoteItemsList, ...relatedBuyerQuoteItems]
            }
        })
        const calculatedResult = calculateBuyerQuotation(newBuyerQuote, buyerQuoteItemsList)

        let maxLogisticGSTRate = 0
        bQuotLogisticsGSTRateOptions.forEach(eachGSTRate =>{
            if(eachGSTRate >= maxLogisticGSTRate){
                maxLogisticGSTRate = eachGSTRate
            }
        })
        calculatedResult.buyerQuote.logisticsGSTRateOptions = [maxLogisticGSTRate]
        calculatedResult.buyerQuote.bQuotLogisticsGSTRate = maxLogisticGSTRate
        calculatedResult.buyerQuote.maxLogisticGSTRate = maxLogisticGSTRate

        const updatedBuyerQuoteItems = calculatedResult.buyerQuoteItems.map(eachBuyerQuoteItem => {
            eachBuyerQuoteItem.bestAvgSellerPrice = eachBuyerQuoteItem.avgSellerPrice
            return eachBuyerQuoteItem
        })

        setBuyerQuoteItems(updatedBuyerQuoteItems)
        setInitialBuyerQuoteItems(updatedBuyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)

        setsellerReqs(sellerReqItemsResponse.sellerReqs)
        setSellerReqItems(sellerReqItemsResponse.sellerReqItems ? sellerReqItemsResponse.sellerReqItems : [])
        setSellers(sellerReqItemsResponse.sellers)

        setIsActiveBuyerPOExist(false)

        setInitialLoading(false)
    }

    const constructBuyerQuoteData = async (buyerQuoteId) => {
        setInitialLoading(true)

        const buyerQuoteResponse = await getBuyerQuoteByBuyerQuoteId(buyerQuoteId)
        if (buyerQuoteResponse.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Quote', detail: buyerQuoteResponse.data.error, life: 3000 }))
        }

        const updatedBuyerQuote = { ...buyerQuoteResponse.data.buyerQuote }
        updatedBuyerQuote.bQuoteLogisticsOption = updatedBuyerQuote.bQuoteLogisticsOption

        const response = await getBuyerRequirementsById(updatedBuyerQuote.buyerReqId)
        
        const buyerReqItemsIds = response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId)
        const materialRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: buyerReqItemsIds })
        if (materialRes.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Material Details', detail: materialRes.data.error, life: 3000 }))
        }
        
        const updatedMaterialDetails = materialRes.data.map(eachMaterial => {
            return {
                ...eachMaterial, 
                isMaterialIdEditable: false, 
                newMaterialId: '', 
                isProductNameEditable: false, 
                isSpecificationEditable: false, 
                buyerReqId: response.data.buyerRequirement.buyerReqId,
                isBrandEditable: false,
                brand: eachMaterial.brandId
            }
        })

        let updatedBuyerReqItems = response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => {
            const materialDetails = updatedMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachBuyerReqItem.materialId)
            const categoryName = materialCategories.find(eachIndustry => eachIndustry.categoryId === materialDetails.categoryId)?.categoryName
            const brandName = brandData.find(eachBrand => eachBrand.brandId === materialDetails.brandId)?.brandName
            return { 
                ...eachBuyerReqItem, 
                categoryName: categoryName, 
                categoryId: materialDetails.categoryId, 
                brandId: materialDetails.brandId, 
                brandName: brandName
            }
        })
        updatedBuyerReqItems = updatedBuyerReqItems.sort((a, b) => a.buyerReqItemId - b.buyerReqItemId)
        
        const procmartBillAddrIds =  _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const allPrimaryBillAddrIds = _.uniq([...procmartBillAddrIds, response.data.buyerRequirement.billAddrId, updatedBuyerQuote.pmBillAddrId, buyerQuote.billAddrId])
        const billAddrRes = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrIds, paginator: false })
        if (billAddrRes.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'billAddrRes', detail: billAddrRes.data.error, life: 3000 }))
        }
        setAllCompanyBillAddresses(billAddrRes?.data?.data)

        const procmartBillAddrs = billAddrRes?.data?.data?.filter(eachBillAddr => procmartBillAddrIds.includes(eachBillAddr.billAddrId))
        setPMBillAddresses(procmartBillAddrs)

        const allStateIds = procmartBillAddrs.map(eachBillAddr => eachBillAddr.stateId)
        const filteredStates = statesDetails?.filter(eachState => allStateIds.includes(eachState.stateId))
        setProcmartStates(filteredStates)

        let primaryPMBillAddrState = null 
        if(updatedBuyerQuote.pmBillAddrId){
            primaryPMBillAddrState = billAddrRes?.data?.data?.find(eachBillAddr => eachBillAddr.billAddrId === updatedBuyerQuote.pmBillAddrId)
        }
        setSelectedProcmartState(primaryPMBillAddrState?.stateId)

        const buyerComapnyDetails = await getCompanyById(response.data.buyerRequirement.companyId)
        if (buyerComapnyDetails.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Company Details', detail: buyerComapnyDetails.data.error, life: 3000 }))
        }
        setBuyerCompanyDetails(buyerComapnyDetails?.data)

        let materialRateContractRes = []
        if (response.data.buyerRequirement.buyerReqItems?.[0]?.buyerRateContractId) {
            const buyerRateContractIds = response.data.buyerRequirement.buyerReqItems.map(eachReqItem => eachReqItem.buyerRateContractId)
            materialRateContractRes = await getBuyerRateContracts({ buyerRateContractIds: buyerRateContractIds, statusIds: [1, 2], paginator: false })
            if (materialRateContractRes.failure) {
                setInitialLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Rate Contract Details', detail: materialRateContractRes.data.error, life: 3000 }))
            }
        }

        const activeBuyerPORes = await getActiveBuyerPOByBuyerQuoteId(buyerQuoteId)
        if(activeBuyerPORes.failure){
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Active buyer po res', detail: activeBuyerPORes.data.error, life: 3000 }))
        }

        setIsActiveBuyerPOExist(activeBuyerPORes?.data?.isActiveBuyerPOExist)
        setbuyerReq(response.data.buyerRequirement)
        setMaterialDetails(updatedMaterialDetails)
        setInitialMaterialDetails(updatedMaterialDetails)

        const sellerReqItemsResponse = await getSellerDetailsBybuyerReqIdForBuyerQuote(updatedBuyerQuote.buyerReqId)

        let updatedBuyerQuoteItemsList = []
        const deletedBuyerReqItemIds = []
        let bestSellerCombBuyerQuoteItems = []

        response.data.buyerRequirement.buyerReqItems.map(eachBuyerReqItem => {
            const relatedSellerReqItems = sellerReqItemsResponse.sellerReqItems.filter(eachSellerReqItem => {
                if (eachSellerReqItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerReqItem.quotTotalAmountWithTax) {
                    if (eachSellerReqItem.statusId === 2) {
                        const isSellerReqItemUsed = buyerQuoteResponse.data.buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.sellerReqItemId === eachSellerReqItem.sellerReqItemId && eachBuyerQuoteItem.statusId === 1)
                        if (isSellerReqItemUsed) {
                            return true
                        }
                    } else {
                        return true
                    }
                }
                return false
            })

            const relatedQuoteItem = buyerQuoteResponse.data.buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1)
            if (!relatedQuoteItem) {
                deletedBuyerReqItemIds.push(eachBuyerReqItem.buyerReqItemId)
                return
            }

            const allSellerlistPrice = []

            relatedSellerReqItems.map(eachSellerReqItem => {
                if (eachSellerReqItem && !allSellerlistPrice.includes(eachSellerReqItem.quotListPrice)) {
                    allSellerlistPrice.push(eachSellerReqItem.quotListPrice)
                }
            })

            let gstOptions = []
            const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === relatedQuoteItem?.bQuotHSNCode)
            gstOptions = HSNCodeDetails?.map(eachHSNCode => eachHSNCode.GSTRate)

            const relatedMaterialItem = materialRes.data.find(eachMaterialItem => eachMaterialItem.materialId === eachBuyerReqItem.materialId)
            const relateBuyerRateContract = materialRateContractRes?.data?.data?.find?.(eachRCItem => eachRCItem.buyerRateContractId === eachBuyerReqItem.buyerRateContractId)
            let relatedBuyerQuoteItems = []
            let relatedBestSellerCombQuoteItems = []

            relatedSellerReqItems.map(eachSellerReqItem => {
                const relatedBuyerQuoteItem = buyerQuoteResponse.data.buyerQuoteItems.find(eachBuyerQuoteItem => {
                    return eachBuyerQuoteItem.sellerReqItemId === eachSellerReqItem.sellerReqItemId
                })

                const relatedCompanyWarehouse = companyWarehouses.find(eachWarehouse => eachWarehouse.shipAddrId === eachSellerReqItem?.shipAddrId)

                if (relatedBuyerQuoteItem) {
                    const newBuyerQuoteItem = {
                        ...relatedBuyerQuoteItem,
                        bQuotSellerListPrice: eachSellerReqItem.quotListPrice,
                        bQuotSellerGSTRate: eachSellerReqItem.quotGSTRate,
                        sellerLeadTime: eachSellerReqItem.quotLeadTime,
                        warehouseName: relatedCompanyWarehouse?.warehouseName ? relatedCompanyWarehouse?.warehouseName : 'Client',
                        warehouseId: relatedCompanyWarehouse?.warehouseId ? relatedCompanyWarehouse?.warehouseId : null,
                        printedDesc: relatedMaterialItem.productSpecification,
                        brandId: relatedMaterialItem.brandId,
                        categoryId: relatedMaterialItem.categoryId,
                        sellerQuoteQty: eachSellerReqItem.quotQty,
                        gstOptions: gstOptions,
                        allHSNGSTRates: gstOptions,
                        sellerUnitLogistics: eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0,
                        isSellerReqExpired: eachSellerReqItem.statusId === 2 ? true : false,
                        quotHSNCode: eachSellerReqItem.quotHSNCode,
                        maxLogisticGSTRate: null,
                        isUnitPriceEditable: eachBuyerReqItem.buyerRateContractId ? false : true,
                        isLeadTimeEditable: (response.data.buyerRequirement.orderTypeId === 2 && relateBuyerRateContract && relateBuyerRateContract.leadTime) ? false : true,
                    }
                    newBuyerQuoteItem.sellerUnitPriceWithLogistics = newBuyerQuoteItem.bQuotSellerPrice + newBuyerQuoteItem.sellerUnitLogistics
                    if (newBuyerQuoteItem.isSellerReqExpired) {
                        newBuyerQuoteItem.bQuotSellerQty = null
                    }
                    relatedBuyerQuoteItems.push(newBuyerQuoteItem)
                    relatedBestSellerCombQuoteItems.push(newBuyerQuoteItem)
                } else {
                    //If new seller req is added!
                    const newBuyerQuoteItem = {
                        buyerQuoteItemId: uuidv4(),
                        buyerQuoteId: updatedBuyerQuote.buyerQuoteId,
                        buyerReqId: eachSellerReqItem.buyerReqId,
                        buyerReqItemId: eachSellerReqItem.buyerReqItemId,
                        sellerReqItemId: eachSellerReqItem.sellerReqItemId,
                        materialId: relatedMaterialItem.materialId,
                        printedDesc: relatedMaterialItem.productSpecification,
                        // companyERPCode: "",
                        totReqQty: relatedQuoteItem.totReqQty,
                        bQuotSellerQty: null,
                        bQuotSellerPrice: eachSellerReqItem.quotUnitPrice,
                        bQuotListPrice: relatedQuoteItem.bQuotListPrice, 
                        bQuotUnitPrice: relatedQuoteItem?.bQuotUnitPrice,
                        bQuotSellerDiscountRate: eachSellerReqItem.quotDiscountRate,
                        bQuotDiscountRate: relatedQuoteItem.bQuotDiscountRate,
                        bQuotMarginRate: relatedQuoteItem.bQuotMarginRate,
                        bQuoteGSTRate: relatedQuoteItem.bQuoteGSTRate,
                        bQuoteItemAmountBeforeTax: relatedQuoteItem?.bQuoteItemAmountBeforeTax,
                        bQuoteItemAmountWithTax: relatedQuoteItem?.bQuoteItemAmountWithTax,
                        bQuotHSNCode: relatedQuoteItem.bQuotHSNCode, 
                        leadTime: relatedQuoteItem.leadTime,
                        statusId: 1,
                        buyerRateContractId: eachBuyerReqItem.buyerRateContractId,
                        companyERPCode: eachBuyerReqItem.companyERPCode,
                        brandId: relatedMaterialItem.brandId,
                        categoryId: relatedMaterialItem.categoryId,
                        warehouseName: relatedCompanyWarehouse?.warehouseName ? relatedCompanyWarehouse?.warehouseName : 'Client',
                        warehouseId: relatedCompanyWarehouse?.warehouseId ? relatedCompanyWarehouse?.warehouseId : null,
                        quotHSNCode: eachSellerReqItem.quotHSNCode,

                        isNew: true,
                        isLeadTimeEditable: (response.data.buyerRequirement.orderTypeId === 2 && relateBuyerRateContract && relateBuyerRateContract.leadTime) ? false : true,
                        bQuotSellerListPrice: eachSellerReqItem.quotListPrice,
                        bQuotSellerGSTRate: eachSellerReqItem.quotGSTRate,
                        sellerLeadTime: eachSellerReqItem.quotLeadTime,
                        //hsnEnable: true,
                        gstOptions: gstOptions,
                        allHSNGSTRates: gstOptions,
                        sellerQuoteQty: eachSellerReqItem.quotQty,
                        sellerUnitLogistics: eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0,
                        isSellerReqExpired: eachSellerReqItem.statusId === 2 ? true : false,
                        maxLogisticGSTRate: null,
                        isUnitPriceEditable: eachBuyerReqItem.buyerRateContractId ? false : true
                    }
                    newBuyerQuoteItem.sellerUnitPriceWithLogistics = newBuyerQuoteItem.bQuotSellerPrice + newBuyerQuoteItem.sellerUnitLogistics
                    relatedBuyerQuoteItems.push(newBuyerQuoteItem)
                    //updatedBuyerQuoteItemsList.push(newBuyerQuoteItem)
                    relatedBestSellerCombQuoteItems.push(newBuyerQuoteItem)
                }
            })

            const totalSellerQuoteQty = _.sumBy(relatedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty) || 0)
            const weightedSum = _.sumBy(relatedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bQuotSellerQty) || 0)
            const totalQuantity = _.sumBy(relatedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty) || 0)
            const weightedAverageSellerPrice = round(weightedSum / totalQuantity, 2)

            const buyerUnitPrice = relatedBuyerQuoteItems[0].bQuotUnitPrice

            const avgSellerPrice = weightedAverageSellerPrice
            const marginAmount = buyerUnitPrice - avgSellerPrice
            const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 2)

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId) {
                    eachBuyerQuoteItem.bQuotMarginRate = marginPercent
                    eachBuyerQuoteItem.totReqQty = totalSellerQuoteQty
                }
                return eachBuyerQuoteItem
            })

            relatedBuyerQuoteItems.sort((a, b) => b.bQuotSellerQty - a.bQuotSellerQty)

            let totalSellerTotalQty = 0
            relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                totalSellerTotalQty += eachBuyerQuoteItem.sellerQuoteQty
            })
            const maxBestSellerTotalQty = totalSellerTotalQty > eachBuyerReqItem.qty ? eachBuyerReqItem.qty : totalSellerTotalQty

            const bestSellerCombination = getBestSellerCombination(relatedBuyerQuoteItems, maxBestSellerTotalQty)

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                const relatedBestSellerQuote = bestSellerCombination.find(eachBestSellerQuote => eachBestSellerQuote.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
                if (relatedBestSellerQuote) {
                    eachBuyerQuoteItem.bestBQuotSellerQty = relatedBestSellerQuote.sellerQuoteQty
                }
                return eachBuyerQuoteItem
            })

            const selectedBuyerQuoteItems = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bestBQuotSellerQty)

            const bestSellerWeightedSum = _.sumBy(selectedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bestBQuotSellerQty))
            const bestSellerTotalQuantity = _.sumBy(selectedBuyerQuoteItems, obj => parseFloat(obj.bestBQuotSellerQty))
            const bestSellerWeightedAverageSellerPrice = round(bestSellerWeightedSum / bestSellerTotalQuantity, 2)

            relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                eachBuyerQuoteItem.bestAvgSellerPrice = bestSellerWeightedAverageSellerPrice
            })


            //GST RATE LOGIC
            const maxSellerGST = _.max(relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerQty).map(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerGSTRate))
            const updatedGSTOptions = relatedBuyerQuoteItems?.[0]?.gstOptions.filter(eachGST => eachGST >= maxSellerGST)

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachQuoteItem => {
                return {...eachQuoteItem, gstOptions: updatedGSTOptions}
            })

            updatedBuyerQuoteItemsList = [...updatedBuyerQuoteItemsList, ...relatedBuyerQuoteItems]

        })
        const calculatedResult = calculateBuyerQuotation(updatedBuyerQuote, updatedBuyerQuoteItemsList)

        updatedBuyerReqItems = updatedBuyerReqItems.filter(eachBuyerReqItem => !deletedBuyerReqItemIds.includes(eachBuyerReqItem.buyerReqItemId))

        let bQuotLogisticsGSTRateOptions = []
        updatedBuyerQuoteItemsList = calculatedResult.buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (!bQuotLogisticsGSTRateOptions.includes(eachBuyerQuoteItem.bQuoteGSTRate)){ 
                bQuotLogisticsGSTRateOptions.push(eachBuyerQuoteItem.bQuoteGSTRate)
            }
            return eachBuyerQuoteItem
        })

        let maxLogisticGSTRate = _.maxBy(bQuotLogisticsGSTRateOptions)
        calculatedResult.buyerQuote.logisticsGSTRateOptions = _.uniqBy([maxLogisticGSTRate, calculatedResult.buyerQuote.bQuotLogisticsGSTRate])
        calculatedResult.buyerQuote.maxLogisticGSTRate = maxLogisticGSTRate

        setBuyerReqItems(updatedBuyerReqItems)
        setsellerReqs(sellerReqItemsResponse.sellerReqs)
        setSellerReqItems(sellerReqItemsResponse.sellerReqItems ? sellerReqItemsResponse.sellerReqItems : [])
        setSellers(sellerReqItemsResponse.sellers)
        setBuyerQuote(calculatedResult.buyerQuote)
        setBuyerQuoteItems(updatedBuyerQuoteItemsList)
        setInitialBuyerQuoteItems(JSON.parse(JSON.stringify(updatedBuyerQuoteItemsList)))

        //approval instances
        const approvalInstanceRes = await getApprovalInstancesByDocNo({ docNo: calculatedResult.buyerQuote.docNo })
        if (approvalInstanceRes.failure) {
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000 }))
        }

        const quoteMarginRes = await getQuoteMargins({paginator: false, companyGroupIds: [buyerComapnyDetails.data.groupId, 0], pmBranchIds: [calculatedResult.buyerQuote.pmBranchId, 0]})
        if(quoteMarginRes.failure){
            setInitialLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Quote Margins', detail: quoteMarginRes.data.error, life: 3000 }))
        }
        setQuoteMargins(quoteMarginRes.data)

        setApprovalInstances(approvalInstanceRes.data)
        setInitialLoading(false)
    }

    const getBestSellerCombination = (sellerQuotes, totReqQty) => {
        sellerQuotes.sort((a, b) => a.sellerUnitPriceWithLogistics - b.sellerUnitPriceWithLogistics);

        let bestCombination = [];
        let remainingQty = totReqQty;

        for (let i = 0; i < sellerQuotes.length && remainingQty > 0; i++) {
            const seller = sellerQuotes[i];
            const qtyToUse = Math.min(remainingQty, seller.sellerQuoteQty);

            if (qtyToUse > 0) {
                bestCombination.push({
                    sellerQuoteQty: qtyToUse,
                    bQuotSellerPrice: seller.bQuotSellerPrice,
                    sellerUnitPriceWithLogistics: seller.sellerUnitPriceWithLogistics,
                    buyerQuoteItemId: seller.buyerQuoteItemId,
                });

                remainingQty -= qtyToUse;
            }
        }

        return bestCombination;
    }

    const calculateTotalVendorScore = (sellerDetails, buyerReqItem, sellerReqs, sellerReqItems) => {
        let totalProductVendorScore = 0
        let totalProductQuotationScore = 0

        sellerDetails = sellerDetails?.map(eachSeller => {
            if (eachSeller.businessTypeId === null) {
                eachSeller.businessTypeId = 5
            }
            let relatedBusinessType = companyBusinessTypes?.find(eachBusinessType => eachBusinessType.businessTypeId === eachSeller.businessTypeId)
            let relatedSellerReqItem
            if (relatedBusinessType) {
                let totalWeightage = 0
                totalWeightage += relatedBusinessType.sourcingWeight
                const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === eachSeller?.userId)
                relatedSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.sellerReqId === relatedSellerReq?.sellerReqId && eachSellerReqItem?.buyerReqItemId === buyerReqItem?.buyerReqItemId && eachSellerReqItem?.statusId === 1)
                if (!relatedSellerReqItem?.isNew) {
                    totalProductVendorScore += relatedBusinessType?.sourcingWeight
                    if (relatedSellerReqItem?.quotUnitPrice > 0) {
                        totalProductQuotationScore += relatedBusinessType?.sourcingWeight
                    }
                }
            }

            return { ...eachSeller, weightage: relatedBusinessType?.sourcingWeight }
        })

        return { totalProductVendorScore, totalProductQuotationScore }
    }

    const handleRemoveListItem = (id) => {
        const updatedBuyerReqItem = buyerReqItems.map(eachReqItem => {
            if (eachReqItem.buyerReqItemId === id) {
                return { ...eachReqItem, statusId: 2 }
            }
            return eachReqItem
        })

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachQuoteItem => {
            if (eachQuoteItem.buyerReqItemId === id) {
                return { ...eachQuoteItem, statusId: 2, bQuotSellerQty: 0 }
            }
            return eachQuoteItem
        })

        const updatedBuyerQuote = handleMaxLogisticGSTRateChange(buyerQuote, updatedBuyerQuoteItems)

        setBuyerQuote(updatedBuyerQuote)
        setBuyerReqItems(updatedBuyerReqItem)
        setBuyerQuoteItems(updatedBuyerQuoteItems)
    }

    const handleMaxLogisticGSTRateChange = (buyerQuote, buyerQuoteItems) => {
        const updatedBuyerQuote = { ...buyerQuote }
        const allGSTRates = []
        buyerQuoteItems.forEach(eachQuoteItem => {
            if (eachQuoteItem.statusId === 1) allGSTRates.push(eachQuoteItem.bQuoteGSTRate)
        })

        const prevMaxLogisticCharge = updatedBuyerQuote.bQuotLogisticsGSTRate
        const newMaxLogisticCharge = _.maxBy(_.compact(allGSTRates))
        if (newMaxLogisticCharge !== prevMaxLogisticCharge) {
            updatedBuyerQuote.logisticsGSTRateOptions.pop(prevMaxLogisticCharge)

            updatedBuyerQuote.logisticsGSTRateOptions.push(newMaxLogisticCharge)

            updatedBuyerQuote.bQuotLogisticsGSTRate = newMaxLogisticCharge
            updatedBuyerQuote.maxLogisticGSTRate = newMaxLogisticCharge
        }

        return updatedBuyerQuote
    }

    const handleGSTRateOptions = (buyerQuoteItems, buyerReqItemId) => {

        const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachQuoteItem => eachQuoteItem.buyerReqItemId === buyerReqItemId)

        const gstRates = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerQty).map(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerGSTRate)

        let updatedGSTOptions = []
        if(gstRates.length > 0){        
            const maxSellerGST = _.max(gstRates)
            const relatedBuyerQuoteItem = buyerQuoteItems.find(eachQuoteItem => eachQuoteItem.buyerReqItemId === buyerReqItemId)
            updatedGSTOptions = relatedBuyerQuoteItem.allHSNGSTRates.filter(eachGST => eachGST >= maxSellerGST)
        }

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachQuoteItem => {
            if(eachQuoteItem.buyerReqItemId === buyerReqItemId){
                return { ...eachQuoteItem, gstOptions: updatedGSTOptions }
            }
            return eachQuoteItem
        })

        return updatedBuyerQuoteItems
    }

    const handleSellerQuantity = (id, name, value) => {
        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachQuoteItem => {
            if (eachQuoteItem.buyerQuoteItemId === id) {
                return { ...eachQuoteItem, [name]: value }
            }
            return eachQuoteItem
        })

        setBuyerQuoteItems([...updatedBuyerQuoteItems])
    }

    const updatedRelatedApprovalInstance = (approvalInstances, relatedApprovalInstance) => {
        const updatedApprovalInstances = approvalInstances.map(eachInstance => {
            if (eachInstance.approvalInstanceId === relatedApprovalInstance.approvalInstanceId) {
                return { ...eachInstance, statusId: 2 }
            }
            return eachInstance
        })

        return updatedApprovalInstances
    }

    const handleRemarks = (id, text) => {
        const updateRequiredApprovals = requiredApprovals.map(eachApproval => {
            if (eachApproval?.approvalId === id) {
                return { ...eachApproval, remarks: text }
            }
            return eachApproval
        })

        setRequiredApprovals(updateRequiredApprovals)
    }

    const handleApprover = (id, userId) => {
        const updateRequiredApprovals = requiredApprovals.map(eachApproval => {
            if (eachApproval?.approvalId === id) {
                return { ...eachApproval, notifyToUserId: userId }
            }
            return eachApproval
        })

        setRequiredApprovals(updateRequiredApprovals)
    }

    
    const handleMaterialDetailsChange = (relatedMaterialDetails) => {
        const updatedMaterialDetails = materialDetails.map(eachMaterial =>{ 
            if(eachMaterial.materialId === relatedMaterialDetails.materialId){
                return {...eachMaterial, ...relatedMaterialDetails}
            }
            return eachMaterial
        })

        setMaterialDetails(updatedMaterialDetails)
    }

    const handleBuyerReqItemsUpdation = (newMaterialId, oldMaterialId, updatedMaterialDetails) => {
        const updatedBuyerReqItemsWithPermMaterialId = buyerReqItems.map(eachReqItem => {
            if (eachReqItem.materialId === oldMaterialId) {
                const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === updatedMaterialDetails.categoryId)
                const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === updatedMaterialDetails.brandId)
                return { 
                    ...eachReqItem, 
                    materialId: parseInt(newMaterialId), 
                    categoryName: relatedCategory.categoryName, 
                    categoryId: updatedMaterialDetails.categoryId, 
                    brandId: updatedMaterialDetails.brandId, 
                    brandName: relatedBrand.brandName, 
                    UOMValue: updatedMaterialDetails.UOMValue }
            }
            return eachReqItem
        })

        setBuyerReqItems([...updatedBuyerReqItemsWithPermMaterialId])
    }

    const handleSellerReqItemsUpdation = (newMaterialId, oldMaterialId) => {
        const updatedSellerReqItemsWithPermMaterialId = sellerReqItems.map(eachSelReqItem => {
            if(eachSelReqItem.materialId === oldMaterialId){
                return {...eachSelReqItem, materialId: newMaterialId}
            }
            return eachSelReqItem
        })

        setSellerReqItems([...updatedSellerReqItemsWithPermMaterialId])
    }

    const handleBuyerQuoteItemsUpdation = (newMaterialId, oldMaterialId) => {
        const updatedBuyerQuoteItemsWithPermMaterialId = buyerQuoteItems.map(eachBuyQuoteItem => {
            if((eachBuyQuoteItem.materialId === oldMaterialId)){
                return {...eachBuyQuoteItem, materialId: newMaterialId}
            }
            return eachBuyQuoteItem
        })

        setBuyerQuoteItems([...updatedBuyerQuoteItemsWithPermMaterialId])
    }

    const handleMaterialDataUpdationByBuyerReqItemId = (newMaterialData) => {
        const updatedMaterialDetails = materialDetails.map(eachMaterial => {
            if(eachMaterial.buyerReqItemId === newMaterialData.buyerReqItemId){
                return {...eachMaterial, ...newMaterialData}
            }
            return eachMaterial
        })

        setMaterialDetails([...updatedMaterialDetails])
    }
    
    const getUpdatedApprovals = (approvalRequestStatusDetails, newQuote, approvalInstances) => {
        let updatedApprovalInstances = []

        approvalInstances.map(eachApprovalInstance => {
            const relatedApprovalRequestStatusDetail = approvalRequestStatusDetails.find(eachDetail => eachApprovalInstance.approvalInstanceId === eachDetail.approvalInstanceId)
            if(relatedApprovalRequestStatusDetail){
                if(relatedApprovalRequestStatusDetail.statusId === 12){
                    eachApprovalInstance.approvedMetrics = relatedApprovalRequestStatusDetail.approvedMetrics
                }
                updatedApprovalInstances.push(eachApprovalInstance)
            } else if(eachApprovalInstance.statusId === 12){
                eachApprovalInstance.statusId = 2
                updatedApprovalInstances.push(eachApprovalInstance)
            } else {
                updatedApprovalInstances.push(eachApprovalInstance) // not required
            }
        })

        const newApprovalInstances = approvalRequestStatusDetails.filter(eachDetail => eachDetail.isNew)
        //updatedApprovalInstances = [...updatedApprovalInstances, ...newApprovalInstances]
        updatedApprovalInstances = [...updatedApprovalInstances]

        updatedApprovalInstances = updatedApprovalInstances.map(eachApproval => {
            return { ...eachApproval, docNo: newQuote.docNo, parentDocNo: buyerReq.docNo, buyerCompanyId: newQuote.companyId, docTypeId: 13, docId: newQuote.buyerQuoteId } //hard coding docTypeId for now!
        })
        return updatedApprovalInstances
    }

    const getBuyerQuoteItemProfit = (buyerQuoteItems) => {
        const buyerQuoteItem = buyerQuoteItems[0]
        let totalSellersPrice = 0
        let allSellerLeadTimes = []

        buyerQuoteItems.forEach(eachBuyerQuoteItem => {
            let beforeTax = 0
            let totalTax = 0
            let totalPrice = 0

            if (eachBuyerQuoteItem.bQuotSellerQty) {
                eachBuyerQuoteItem.bQuotSellerQty = round(eachBuyerQuoteItem.bQuotSellerQty)
                beforeTax = round(eachBuyerQuoteItem.bQuotSellerQty * eachBuyerQuoteItem.bQuotSellerPrice)
                totalPrice = beforeTax
                totalTax = 0

                if (eachBuyerQuoteItem.bQuotSellerGSTRate) {
                    totalTax = round(eachBuyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
                    totalPrice = totalTax + beforeTax
                }
                if (eachBuyerQuoteItem.bQuotSellerQty > 0) {
                    allSellerLeadTimes.push(eachBuyerQuoteItem.sellerLeadTime)
                }
            }
            totalSellersPrice += totalPrice
        })

        let profit = round(buyerQuoteItem.bQuoteItemAmountWithTax - totalSellersPrice)
        profit = profit || profit

        return profit
    }

    const getMarginCalc = (avgSellerPrice, bQuotListPrice, marginPercent) => {
        //const marginAmount = (avgSellerPrice * marginPercent) / 100
        const buyerUnitPrice = round(avgSellerPrice / (1 - (marginPercent / 100)), 2)

        const discountAmount = bQuotListPrice - buyerUnitPrice
        const discountPercent = round((discountAmount / bQuotListPrice) * 100, 2)
        return { buyerUnitPrice, discountPercent }
    }

    const getUnitPriceCalc = (bQuotListPrice, buyerUnitPrice, avgSellerPrice) => {
        const discountAmount = bQuotListPrice - buyerUnitPrice
        const discountPercent = round((discountAmount / bQuotListPrice) * 100, 5)

        const marginAmount = buyerUnitPrice - avgSellerPrice
        const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 5)

        return { discountPercent, marginPercent }
    }

    const getBestQuoteMargin = (quoteMargins) => {
        const quoteMarginsWithScore = quoteMargins.map(eachQuoteMargin => {
            const categoryExactMatch = eachQuoteMargin.categoryId ? 3 : 0
            const pmBranchExactMatch = eachQuoteMargin.pmBranchId ? 2 : 0
            const companyGroupExactMatch = eachQuoteMargin.companyGroupId ? 1 : 0

            const exactMatchesCount = (categoryExactMatch ? 1 : 0) + (pmBranchExactMatch ? 1 : 0) + (companyGroupExactMatch ? 1 : 0)

            const score = categoryExactMatch + pmBranchExactMatch + companyGroupExactMatch
            return { ...eachQuoteMargin, score: score, exactMatchesCount: exactMatchesCount }
        })
    
        const  bestQuoteMargin = _.chain(quoteMarginsWithScore).orderBy(
            ['score', 'exactMatchesCount', 'categoryId', 'pmBranchId', 'companyGroupId'],
            ['desc', 'desc', 'desc', 'desc', 'desc'] 
        ).head().value()

        return bestQuoteMargin
    }

    const getSuggMarginQuoteItems = (quoteMargins, quoteClasses, buyerReq, buyerReqItems, buyerQuote, buyerQuoteItems) => {
        let buyerReqItemIds = buyerQuoteItems.map(eachQuoteItem => eachQuoteItem.buyerReqItemId)
        buyerReqItemIds = _.uniqBy(buyerReqItemIds)

        let suggMarginBuyerQuoteItems = []
        if (quoteMargins.length && buyerReq.orderTypeId === 1 && ![3, 10].includes(buyerQuote.pmBranchId) && !buyerReq.isRouted && ![2, 4].includes(buyerReq.reqTagId)) {
            const activeBuyerReqItems = buyerReqItems.filter(eachBuyerReqItem => buyerReqItemIds.includes(eachBuyerReqItem.buyerReqItemId))
            const relatedQuoteClass = quoteClasses.find(eachQuoteClass => {
                return parseFloat(eachQuoteClass.minValue) <= parseFloat(buyerQuote.bQuotTotalItemAmountWithTax) && parseFloat(eachQuoteClass.maxValue) >= parseFloat(buyerQuote.bQuotTotalItemAmountWithTax)
            })

            activeBuyerReqItems.forEach(eachReqItem => {
                if (![4, 28].includes(eachReqItem.categoryId)) {
                    const relatedQuoteMargins = quoteMargins.filter(eachQuoteMargin => {
                        return eachQuoteMargin.quoteClassId === relatedQuoteClass.quoteClassId
                            && ([eachReqItem.categoryId, 0].includes(eachQuoteMargin.categoryId))
                            && ([buyerQuote.pmBranchId, 0].includes(eachQuoteMargin.pmBranchId))
                            && ([buyerCompanyDetails.groupId, 0].includes(eachQuoteMargin.companyGroupId))
                    })

                    const bestQuoteMargin = getBestQuoteMargin(relatedQuoteMargins)
                    if (bestQuoteMargin) {
                        let cummulativeBestQuoteMargin = (parseFloat(bestQuoteMargin.baseMargin) || 0) + (parseFloat(bestQuoteMargin.genericPremium) || 0) + (parseFloat(bestQuoteMargin.categoryQuoteClassPremium) || 0)
                        cummulativeBestQuoteMargin = cummulativeBestQuoteMargin + parseFloat(relatedQuoteClass.additionalMargin) || 0

                        let suggMargin = cummulativeBestQuoteMargin > parseFloat(relatedQuoteClass.minMargin) ? cummulativeBestQuoteMargin : parseFloat(relatedQuoteClass.minMargin)
                        suggMargin = Math.round(suggMargin)

                        let relatedBuyerQuoteItems = buyerQuoteItems.filter(eachQuoteItem => eachQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)

                        let relatedSuggMarginBuyerQuoteItems = [...relatedBuyerQuoteItems]
                        if (suggMargin > parseFloat(relatedBuyerQuoteItems[0].bQuotMarginRate)) {
                            relatedSuggMarginBuyerQuoteItems = relatedSuggMarginBuyerQuoteItems.map(eachQuoteItem => {
                                const avgSellerPrice = eachQuoteItem.avgSellerPrice
                                const bQuotListPrice = eachQuoteItem.bQuotListPrice

                                //const marginAmount = (avgSellerPrice * suggMargin) / 100
                                const buyerUnitPrice = round(avgSellerPrice / (1 - (suggMargin / 100)), 2)

                                const discountAmount = bQuotListPrice - buyerUnitPrice
                                const discountPercent = round((discountAmount / bQuotListPrice) * 100, 2)

                                let maxSuggMargin = suggMargin
                                let maxUnitPrice = buyerUnitPrice
                                if (suggMargin < 20) {
                                    maxSuggMargin = 20
                                    //const marginAmount = (avgSellerPrice * maxSuggMargin) / 100
                                    maxUnitPrice = round(avgSellerPrice / (1 - (maxSuggMargin / 100)), 2)
                                }

                                return {
                                    ...eachQuoteItem,
                                    bQuotMarginRate: suggMargin,
                                    bQuotUnitPrice: buyerUnitPrice,
                                    bQuotDiscountRate: discountPercent,
                                    suggMargin: suggMargin,
                                    quotedMargin: eachQuoteItem.bQuotMarginRate,
                                    maxSuggMargin: maxSuggMargin,
                                    maxUnitPrice: maxUnitPrice
                                }
                            })
                            const calculateSuggMarginBuyerQuoteItems = calculateBuyerQuotation(buyerQuote, relatedSuggMarginBuyerQuoteItems)

                            const suggMarginProfit = getBuyerQuoteItemProfit(calculateSuggMarginBuyerQuoteItems.buyerQuoteItems)
                            const quotedMarginProfit = getBuyerQuoteItemProfit(relatedBuyerQuoteItems)

                            relatedSuggMarginBuyerQuoteItems = calculateSuggMarginBuyerQuoteItems.buyerQuoteItems.map(eachQuoteItem => {
                                return {
                                    ...eachQuoteItem,
                                    suggMarginChecked: true,
                                    suggMarginProfit: suggMarginProfit,
                                    quotedMarginProfit: quotedMarginProfit,
                                    quotedUnitPrice: relatedBuyerQuoteItems[0].bQuotUnitPrice,
                                    suggUnitPrice: eachQuoteItem.bQuotUnitPrice

                                }
                            })

                            suggMarginBuyerQuoteItems = [...suggMarginBuyerQuoteItems, ...relatedSuggMarginBuyerQuoteItems]
                        }
                    }
                }
            })
        }

        let calculatedSuggMarginBuyerQuote = null
        if(suggMarginBuyerQuoteItems.length){
            let activeBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.statusId === 1 && eachBuyerQuoteItem.bQuotSellerQty)
            const allBuyerQuoteItems = activeBuyerQuoteItems.map(eachQuoteItem => {
                const relatedBuyerQuoteItem = suggMarginBuyerQuoteItems.find(eachSuggMarginBuyerQuoteitem => eachSuggMarginBuyerQuoteitem.buyerQuoteItemId === eachQuoteItem.buyerQuoteItemId)
                if(relatedBuyerQuoteItem){
                    return relatedBuyerQuoteItem
                }
                return eachQuoteItem
            })
    
            const calculatedResult = calculateBuyerQuotation(buyerQuote, allBuyerQuoteItems)
            calculatedSuggMarginBuyerQuote = calculatedResult.buyerQuote
        }
        if(calculatedSuggMarginBuyerQuote){
            calculatedSuggMarginBuyerQuote.isSuggMarginApplied = true
        }

        return {suggMarginBuyerQuote: calculatedSuggMarginBuyerQuote, suggMarginBuyerQuoteItems}
    }

    const handleUpdatedBuyerQuoteItemsSuggMargins = (relatedSuggMarginBuyerQuoteItems) => {
        let updatedBuyerQuoteitems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            const relatedBuyerQuoteItem = relatedSuggMarginBuyerQuoteItems.find(eachSuggMarginBuyerQuoteitem => eachSuggMarginBuyerQuoteitem.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
            if (relatedBuyerQuoteItem) {
                return relatedBuyerQuoteItem
            }
            return eachBuyerQuoteItem
        })

        let activeBuyerQuoteItems = updatedBuyerQuoteitems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.statusId === 1 && eachBuyerQuoteItem.bQuotSellerQty)
        
        const calculatedResult = calculateBuyerQuotation(buyerQuote, activeBuyerQuoteItems)

        setSuggMarginBuyerQuoteItems([])
        setVisibleMarginSuggestion(false)

        //setBuyerQuote(calculatedResult.buyerQuote)
        //const updatedBuyerQuoteItems = updatedBuyerQuoteitems.filter()
        //setBuyerQuoteItems([...calculatedResult.buyerQuoteItems, ...deletedBuyerQuoteItems])
        //setBuyerQuoteItems(updatedBuyerQuoteitems)
        //setBuyerQuoteItems(JSON.parse(JSON.stringify(calculatedResult.buyerQuoteItems)))

        updatedBuyerQuoteitems = updatedBuyerQuoteitems.map(eachBuyerQuoteItem => {
            const relatedBuyerQuoteItem = calculatedResult.buyerQuoteItems.find(eachSuggMarginBuyerQuoteitem => eachSuggMarginBuyerQuoteitem.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
            if (relatedBuyerQuoteItem) {
                return relatedBuyerQuoteItem
            } else {
                const relatedReqBuyerQuoteItem = calculatedResult.buyerQuoteItems.find(eachSuggMarginBuyerQuoteitem => eachSuggMarginBuyerQuoteitem.buyerReqItemId === eachBuyerQuoteItem.buyerReqItemId)
                
                if(relatedReqBuyerQuoteItem){
                    let updatedObj = {
                        ...eachBuyerQuoteItem,
                        bQuotDiscountRate: relatedReqBuyerQuoteItem.discountPercent,
                        bQuotUnitPrice: relatedReqBuyerQuoteItem.bQuotUnitPrice,
                        bQuotMarginRate: relatedReqBuyerQuoteItem.bQuotMarginRate
                    }
                    return updatedObj
                }
            }
            return eachBuyerQuoteItem
        })

        let deletedBuyerQuoteItems = updatedBuyerQuoteitems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerQuoteItemId && !eachBuyerQuoteItem.isNew && !eachBuyerQuoteItem.bQuotSellerQty)
        saveBuyerQuote(calculatedResult, deletedBuyerQuoteItems)

        setBuyerQuoteItems(updatedBuyerQuoteitems)
    }

    const buyerQuoteValidations = async () => {
        if(isStarRFQ && hasNullDocProof){
            return dispatch(raiseToast({ severity: 'error', detail: `Please upload pending proof on seller req page.`, life: 3000 }))
        }
        let activeBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.statusId === 1 && eachBuyerQuoteItem.bQuotSellerQty)
        
        const calculatedResult = calculateBuyerQuotation(buyerQuote, activeBuyerQuoteItems)

        activeBuyerQuoteItems = calculatedResult.buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.statusId === 1)

        // //Why?
        const updateRequiredItems = activeBuyerQuoteItems.filter(eachBuyerQuoteItem => {
            if (!eachBuyerQuoteItem.isNew || eachBuyerQuoteItem.bQuotSellerQty) {
                return true
            }
            return false
        })

        if (activeBuyerQuoteItems.length === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please add at least one product`, life: 3000 }))
        }

        if (buyerReq.orderTypeId === 3){
            const isServiceHSNsProductsExists = activeBuyerQuoteItems.some(eachBuyerQuoteItem => {
                if(eachBuyerQuoteItem.bQuotHSNCode.toString().slice(0, 2) === '99' && eachBuyerQuoteItem.bQuotHSNCode.toString().length === 6){
                    return true
                }
                return false
            })

            if(isServiceHSNsProductsExists){
                //return dispatch(raiseToast({severity:'error', detail:'Services Should not be added in Stock PO'}))
            }
        }

        //validations for material edit

        const editPendingMaterial = materialDetails.find(eachMaterial => eachMaterial.isMaterialIdEditable || eachMaterial.isProductNameEditable || eachMaterial.isSpecificationEditable)
        if (editPendingMaterial) {
            let inputText = ''
            if(editPendingMaterial.isMaterialIdEditable){
                inputText = 'Material Id'
            }
            else if(editPendingMaterial.isProductNameEditable){
                inputText = 'Product name'
            }
            else if(editPendingMaterial.isSpecificationEditable){
                inputText = 'Specification'
            }
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter ${inputText} for material ${editPendingMaterial.materialId}`, life: 3000 }))
        }

        if (!calculatedResult.buyerQuote.pmBillAddrId || !calculatedResult.buyerQuote.pmCompanyId || !calculatedResult.buyerQuote.pmBranchId) {
            if (!calculatedResult.buyerQuote.pmBillAddrId) return dispatch(raiseToast({ severity: 'error', detail: `Please select procmart state`, life: 3000 }))
            if (!calculatedResult.buyerQuote.pmCompanyId) return dispatch(raiseToast({ severity: 'error', detail: `Please enter pmCompanyId`, life: 3000 }))
            if (!calculatedResult.buyerQuote.pmBranchId) return dispatch(raiseToast({ severity: 'error', detail: `Please enter pmBranchId`, life: 3000 }))
        }

        if(!selectedProcState){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select procmart state`, life: 3000 }))
        }

        //validation-1

        if((parseFloat(buyerQuote.bQuotLogisticsBeforeTax) !== 0 && !buyerQuote.bQuotLogisticsBeforeTax)){
            return dispatch(raiseToast({ severity: 'error', detail: "Please add logistics charge", life: 3000 }))
        }

        let buyerReqItemIds = activeBuyerQuoteItems.map(eachQuoteItem => eachQuoteItem.buyerReqItemId)
        buyerReqItemIds = _.uniqBy(buyerReqItemIds)

        let uniqueBuyerQuoteItems = []
        buyerReqItemIds.forEach(eachReqItemId => {
            buyerQuoteItems.some(eachQuoteItem => {
                if (eachReqItemId === eachQuoteItem.buyerReqItemId && !eachQuoteItem.isSellerReqExpired) {
                    uniqueBuyerQuoteItems.push(eachQuoteItem)
                    return true
                }
                return false
            })
        })

        const unSavedBuyerQuoteItem = uniqueBuyerQuoteItems.find(eachQuoteItem => {
            if (eachQuoteItem.buyerRateContractId && eachQuoteItem.isUnitPriceEditable) {
                return true
            }
            return false
        })

        if(unSavedBuyerQuoteItem){
            return dispatch(raiseToast({ severity: 'error', detail: `Please save unit price for material ${unSavedBuyerQuoteItem.materialId}`, life: 3000 }))
        }

        const isDataNotProvided = uniqueBuyerQuoteItems.some(eachQuoteItem => {
            if (!eachQuoteItem.bQuotListPrice) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter list price for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }

            if (!eachQuoteItem.bQuotHSNCode) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter HSN Code for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }

            if (!eachQuoteItem.leadTime || parseInt(eachQuoteItem.leadTime) === 0) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter Delivery period for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }

            if (!eachQuoteItem.bQuotUnitPrice) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter unit price for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }


            if (!eachQuoteItem.bQuoteGSTRate && eachQuoteItem.bQuoteGSTRate !== 0) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter GST for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            } 

            if (!eachQuoteItem.totReqQty) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter Quantity for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }

            const relatedHSNCode = HSNMasterData.find(eachHSN => eachHSN.HSNCode === parseInt(eachQuoteItem.bQuotHSNCode))
            if (!relatedHSNCode) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter Valid HSN Code for material ID ${eachQuoteItem?.materialId}`, life: 3000 }))
                return true
            }

            return false
        })
        if (isDataNotProvided) return

        const allBuyerReqItemIds = _.uniqBy(activeBuyerQuoteItems.map(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId))
        const validQtys = allBuyerReqItemIds.some(eachBuyerReqItemId => {
            const relatedBuyerQuotes = activeBuyerQuoteItems.filter(eachQuoteItem => eachBuyerReqItemId === eachQuoteItem.buyerReqItemId)
            const allSellerQty = _.sumBy(relatedBuyerQuotes, (obj) => parseFloat(obj.bQuotSellerQty))

            if (parseFloat(allSellerQty) !== parseFloat(relatedBuyerQuotes[0].totReqQty)) {
                const relatedBuyerReqItem = buyerReqItems.find(eachReqItem => eachReqItem.buyerReqItemId === eachBuyerReqItemId)
                dispatch(raiseToast({ severity: 'error', detail: `The seller quote quantity and total required quote quantity should be equal for product material code ${relatedBuyerReqItem.materialId}`, life: 3000 }))
                return true
            }

            const allSellerLeadTimes = []
            relatedBuyerQuotes.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.bQuotSellerQty > 0) {
                    allSellerLeadTimes.push(eachBuyerQuoteItem.sellerLeadTime)
                }
            })
            const maxSellerLeadTime = _.max(allSellerLeadTimes)

            if (relatedBuyerQuotes[0].leadTime < maxSellerLeadTime) {
                dispatch(raiseToast({ severity: 'error', detail: "leadtime should be greater than max seller lead time", life: 3000 }))
                return true
            }

            return false
        })
        if (validQtys) return

        if(parseFloat(calculatedResult.buyerQuote.bQuotLogisticsBeforeTax)){

            if(!calculatedResult.buyerQuote.bQuotLogisticsHSN){
                return dispatch(raiseToast({ severity: 'error', detail: "Please enter logistics HSN", life: 3000 }))
            }

            if(!calculatedResult.buyerQuote.bQuotLogisticsGSTRate && calculatedResult.buyerQuote.bQuotLogisticsGSTRate !== 0){
                return dispatch(raiseToast({ severity: 'error', detail: "Please enter logistics GST rate", life: 3000 }))
            }

            if (Math.abs(calculatedResult.buyerQuote.bQuotLogisticsWithTax - calculatedResult.buyerQuote.totalSellerLogistics) < 1) {
                return dispatch(raiseToast({ severity: 'error', detail: "buyer quotation logistics and seller total logistics should be differed by minimum 1", life: 3000 }))
            }
        }

        let deletedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerQuoteItemId && !eachBuyerQuoteItem.isNew && !eachBuyerQuoteItem.bQuotSellerQty)
        const {suggMarginBuyerQuote, suggMarginBuyerQuoteItems} = getSuggMarginQuoteItems(quoteMargins, quoteClasses, buyerReq, buyerReqItems, calculatedResult.buyerQuote, activeBuyerQuoteItems)

        if(suggMarginBuyerQuoteItems.length){
            setsuggMarginBuyerQuote(suggMarginBuyerQuote)
            setSuggMarginBuyerQuoteItems(suggMarginBuyerQuoteItems)
            setVisibleMarginSuggestion(true)
        }
        else{
            saveBuyerQuote(calculatedResult, deletedBuyerQuoteItems)
        }
    }

    const saveBuyerQuote = async (calculatedResult, deletedBuyerQuoteItems) => {
        const accept = async () => {
            setIsLoading(true)

            const updatedBuyerQuoteItems = calculatedResult.buyerQuoteItems.map(eachBuyerQuoteItem => {
                const relatedSuggMarginBuyerQuoteItem = suggMarginBuyerQuoteItems.find(eachSuggBuyerQuoteItem => eachSuggBuyerQuoteItem.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
                if(relatedSuggMarginBuyerQuoteItem){
                    eachBuyerQuoteItem.suggMargin = relatedSuggMarginBuyerQuoteItem.suggMargin
                }
                return eachBuyerQuoteItem
            })

            const addedQuoteRes = await addBuyerQuote({
                bulkQuote: calculatedResult.buyerQuote,
                buyerQuoteItems: [...updatedBuyerQuoteItems, ...deletedBuyerQuoteItems]
            })

            if (addedQuoteRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: addedQuoteRes.data.error, life: 3000 }))
            }

            const updatedApprovalRequests = getUpdatedApprovals(approvalRequestStatusDetails, addedQuoteRes.data.buyerQuote, approvalInstances)
            if (updatedApprovalRequests.length){
                const newApprovalInstacesRes = await insertApprovalInstances({ requestedApprovals: updatedApprovalRequests })
                if (newApprovalInstacesRes.failure) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Approval Requests', detail: newApprovalInstacesRes.data.error, life: 3000 }))
                }
            }

            setIsLoading(false)
            navigate(`/buyer/quotation/${addedQuoteRes.data.buyerQuote.buyerQuoteId}`)
        }

        const reject = () => {
            //Nothing happens for now
        }

        let confirmText = ''

        const buyerGSTIN = allCompanyBillAddresses.find(eachBillAddr => eachBillAddr.billAddrId === calculatedResult.buyerQuote.billAddrId)?.gstinCode

        const hasLowMarginRate = calculatedResult.buyerQuoteItems?.some(each => each.bQuotMarginRate <= 2)
        const approvalsRequired = requiredApprovals.length > 0
        const isURP = !buyerGSTIN || buyerGSTIN === "URP"
        
        if(approvalsRequired){
            confirmText += `Approvals are required for this quote. `
        }
        if(suggMarginBuyerQuote && suggMarginBuyerQuote.isSuggMarginApplied){
            confirmText += `The Final quote value is greater than initial quote. `
        }
        else if(hasLowMarginRate){
            confirmText += `Margin rate is less than 2%. `
        }
        if(calculatedResult.buyerQuote.skipSuggMarginReasonId === 3){
            confirmText += `This will update the requirement to routed. `
        }
        if(isURP){
            confirmText += `You\'re proceeding with URP buyerGSTIN, `
        }

        confirmText += `Are you sure you want to continue?`

        /*confirmDialog({
            message: confirmText,
            header: 'Save Quote',
            icon: 'pi pi-info-circle',
            rejectLabel: "No",
            acceptLabel: "Yes",
            accept,
            reject
        })*/

        if(window.confirm(confirmText)){
            accept()
        }
    }

    let isEditable = false
    if(buyerQuoteId){
        if(buyerQuote?.createdBy === userDetails?.userId){
            isEditable = true
        }
        else{
            isEditable = getBranchComparision(userDetails?.activeUserRoleDetails?.branchId, buyerQuote?.pmBranchId)
        }
    }    

    let tooltipText = ''
    if(isActiveBuyerPOExist){
        tooltipText = "Can't create a quote if an active buyer PO exist"
    }
    else if(buyerQuoteId && !isEditable){
        tooltipText = "Only quote created person and their branch related persons can Edit."
    }

    const isRateContract = buyerQuoteItems?.[0]?.buyerRateContractId

    const renderAuditProductMobileSkeleton = () => <AuditProductMobileSkeleton />
    const renderAuditProductSkeleton = () => <AuditProductSkeleton />

    if(isInitialLoading){
        return(
            isMobile() ? renderAuditProductMobileSkeleton() : renderAuditProductSkeleton()
        )
    }


    return (
        <>
            <div className="audit-product mb-3">
            <div className="flex flex-row justify-content-between mb-0 ml-2">
                {buyerQuote?.docNo ?
                    <p className="m-0" style={{ fontSize: "14px" }}>
                        Quotation No: <span style={{ fontSize: "15px", fontWeight: "bold" }}>{buyerQuote?.docNo}</span>
                        <CopyToClipboard text={buyerQuote?.docNo} />
                    </p>
                    :
                    <p className="m-0" style={{ fontSize: "14px" }}>
                        Requirement No: <span style={{ fontSize: "15px", fontWeight: "bold" }}>{buyerReq?.docNo}</span>
                        <CopyToClipboard text={buyerReq?.docNo} />
                    </p>
                }
                <div className="flex mr-2 m-0 text-600"><h4 className="m-0">{isRateContract ? 'RATE CONTRACT' : 'ADHOC'} | {buyerReq?.isRouted ? 'ROUTED' : 'NOT ROUTED'}</h4></div>
            </div>
            <div className="flex">
                {/* <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                    <SelectState buyerQuote={buyerQuote} setBuyerQuote={setBuyerQuote} buyerQuoteBillAddrr={buyerQuote?.billAddrId} statesDetails={statesDetails} />
                </div> */}
                <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                    <SelectStateNew 
                        buyerQuote={buyerQuote} 
                        pmBillAddresses={pmBillAddresses}
                        setBuyerQuote={setBuyerQuote} 
                        allCompanyBillAddresses={allCompanyBillAddresses} 
                        procmartStates={procmartStates} 
                        setSelectedProcmartState={setSelectedProcmartState}
                        statesDetails={statesDetails} 
                        selectedProcState={selectedProcState}
                    />
                </div>
                <div className="flex flex-column col-12 lg:col-8 lg:mb-0">
                    <Commission
                        selectedBuyerReqItemIds={selectedBuyerReqItemIds}
                        setSelectedBuyerReqItemIds={setSelectedBuyerReqItemIds}
                        buyerReqItems={buyerReqItems}
                        buyerQuote={buyerQuote}
                        buyerQuoteItems={buyerQuoteItems}
                        setBuyerQuoteItems={setBuyerQuoteItems}
                        setBuyerQuote={setBuyerQuote}
                        setVisibleApprovals={setVisibleApprovals}
                    />
                </div>
            </div>

            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0 py-0" >
                {buyerReqItems.filter(eachBuyerReqItem => eachBuyerReqItem.statusId === 1).map(eachReqItem => {
                    ////consolelog("industryName", eachReqItem.industryName)

                    const materialCodeDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)
                    // if(!materialCodeDetails){
                    //     materialCodeDetails = {UOM: null, materialId: null, productName: null, varientName: null, productSpecification: null}
                    // }
                    const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                    //relatedBuyerQuoteItems > 0
                    const sellersData = sellerReqItems?.filter(eachSellerItem => eachSellerItem.buyerReqItemId === eachReqItem.buyerReqItemId)

                    return (
                        <ListItem
                            key={`buyerReqItem-${eachReqItem.buyerReqItemId}`}
                            relatedMaterialDetails={materialCodeDetails}
                            relatedBuyerQuoteItems={relatedBuyerQuoteItems}
                            buyerQuoteItems={buyerQuoteItems}
                            sellerReqs={sellerReqs}
                            allSellerDetails={sellers}
                            buyerReqItemDetails={eachReqItem}
                            sellersData={sellersData}
                            brandData={brandData}
                            handleRemoveListItem={handleRemoveListItem}
                            handleSellerQuantity={handleSellerQuantity}
                            setBuyerQuoteItems={setBuyerQuoteItems}
                            buyerQuote={buyerQuote}
                            buyerReq={buyerReq}
                            setBuyerQuote={setBuyerQuote}
                            requiredApprovals={requiredApprovals}
                            quotationApprovals={quotationApprovals}
                            approvalInstances={approvalInstances}
                            approvalRequestStatusDetails={approvalRequestStatusDetails}
                            statusData={statusData}
                            HSNMasterData={HSNMasterData}
                            selectedBuyerReqItemIds={selectedBuyerReqItemIds}
                            initialMaterialDetails={initialMaterialDetails}
                            handleBuyerReqItemsUpdation={handleBuyerReqItemsUpdation}
                            handleSellerReqItemsUpdation={handleSellerReqItemsUpdation}
                            handleBuyerQuoteItemsUpdation={handleBuyerQuoteItemsUpdation}
                            setSelectedBuyerReqItemIds={setSelectedBuyerReqItemIds}
                            handleMaxLogisticGSTRateChange={handleMaxLogisticGSTRateChange}
                            handleGSTRateOptions={handleGSTRateOptions}
                            isStarRFQ={isStarRFQ}
                            hasNullDocProof={hasNullDocProof}
                            handleMaterialDetailsChange={handleMaterialDetailsChange}
                            handleMaterialDataUpdationByBuyerReqItemId={handleMaterialDataUpdationByBuyerReqItemId}
                            setIsLoading={setIsLoading}
                            buyerQuoteId={buyerQuoteId}
                            initialBuyerQuoteItems={initialBuyerQuoteItems}
                            getMarginCalc={getMarginCalc}
                            getUnitPriceCalc={getUnitPriceCalc}
                            materialCategories={materialCategories}
                        />
                    )
                })}
            </div>

            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0 pt-0" >
                <LogisticCharge 
                    buyerQuote={buyerQuote} 
                    buyerQuoteItems={buyerQuoteItems} 
                    setBuyerQuote={setBuyerQuote} 
                    HSNMasterData={HSNMasterData} 
                    approvalRequestStatusDetails={approvalRequestStatusDetails} 
                    quotationApprovals={quotationApprovals}
                />
            </div>
            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0 pt-0" >
                <QuotationDetails buyerQuote={buyerQuote} setBuyerQuote={setBuyerQuote} allCompanyBillAddresses={allCompanyBillAddresses} buyerCompanyDetails={buyerCompanyDetails} pmCompanyConfig={pmCompanyConfig}/>
            </div>
            <div className="flex justify-content-center">
                <Button 
                    label="Save Quote" 
                    onClick={buyerQuoteValidations} 
                    permissions={[7]} 
                    disabled={isActiveBuyerPOExist || (buyerQuoteId && !isEditable)} 
                    tooltip={tooltipText}
                    tooltipOptions={{ position: 'top', showOnDisabled: true, }}
                />
            </div>
            <Dialog header="Approvals" className="approvals-dialog" visible={visibleApprovals} style={{ width: '80vw', height: '85vh' }} onHide={() => setVisibleApprovals(false)}>
                {/* <ApprovalDisplay
                    buyerReqItems={buyerReqItems}
                    buyerQuote={buyerQuote}
                    buyerQuoteItems={buyerQuoteItems}
                    approvalInstances={approvalInstances}
                    quotationApprovals={quotationApprovals}
                    statusData={statusData}
                    materialDetails={materialDetails}
                    requiredApprovals={requiredApprovals}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    brandData={brandData}
                    materialCategories={materialCategories}
                    handleRemarks={handleRemarks}
                    primaryApprovers={primaryApprovers}
                    buyerReq={buyerReq}
                    approvalSecondary={approvalSecondary}
                /> */}
                <NewApprovalsDisplay
                    buyerReqItems={buyerReqItems}
                    buyerQuote={buyerQuote}
                    buyerQuoteItems={buyerQuoteItems}
                    approvalInstances={approvalInstances}
                    quotationApprovals={quotationApprovals}
                    approvalTypes={approvalTypes}
                    statusData={statusData}
                    materialDetails={materialDetails}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    brandData={brandData}
                    materialCategories={materialCategories}
                    handleRemarks={handleRemarks}
                    handleApprover={handleApprover}
                    buyerReq={buyerReq}
                    approvalSecondary={approvalSecondary}
                />
            </Dialog>
                <BuyerQuoteMarginSuggetions
                    pmCompanyConfig={pmCompanyConfig}
                    visibleMarginSuggestion={visibleMarginSuggestion}
                    setVisibleMarginSuggestion={setVisibleMarginSuggestion}
                    buyerQuote={buyerQuote}
                    buyerQuoteItems={buyerQuoteItems}
                    buyerReqItems={buyerReqItems}
                    quoteMargins={quoteMargins}
                    quoteClasses={quoteClasses}
                    getSuggMarginQuoteItems={getSuggMarginQuoteItems}
                    materialDetails={materialDetails}
                    suggMarginBuyerQuoteItems={suggMarginBuyerQuoteItems}
                    setSuggMarginBuyerQuoteItems={setSuggMarginBuyerQuoteItems}
                    getBuyerQuoteItemProfit={getBuyerQuoteItemProfit}
                    suggMarginBuyerQuote={suggMarginBuyerQuote}
                    setsuggMarginBuyerQuote={setsuggMarginBuyerQuote}
                    handleUpdatedBuyerQuoteItemsSuggMargins={handleUpdatedBuyerQuoteItemsSuggMargins}
                    getMarginCalc={getMarginCalc}
                    getUnitPriceCalc={getUnitPriceCalc}
                    pmCompanyDetails={pmCompanyDetails}
                    skipSuggMarginReasons={skipSuggMarginReasons}
                    setBuyerQuote={setBuyerQuote}
                />
            <Loading visible={isLoading} />
        </div>
        </>
    )
}

export default AuditProduct
